import { apiPut } from '@/store/api';
import { GatResponseResult } from '@/types/GatResponseResult';
import getLocationDetail from '@/services/helpers/getLocationDetail';
import { useApplicationStore } from '@/store/applicationStore';
import { useAppStatusStore } from '@/store/appStatusStore';

export interface IAppStatus {
    PortCall?: Object;
    SetupID?: number;
    VesselId?: number;
    ClientId?: number; // or clientId
    ProformaId?: number;
}

export interface EmailGenerationOptions {
    appStatus?: string;
    recipients?: {
        to: { EMAIL: string; NAME?: string }[];
        cc: { EMAIL: string; NAME?: string }[];
        bcc: { EMAIL: string; NAME?: string }[];
    };
}

export async function generateDocument(location: string, locationId: number | string, templateId: string | number, guid: string, isEmail: 0 | 1, portcallProformaId?: number, emailGeneration?: EmailGenerationOptions): Promise<GatResponseResult<any>> { // any for no payload
    const { appStatus: capturedAppStatus, ...generationOptions } = emailGeneration || {};
    let appStatus = capturedAppStatus;
    if (!appStatus) {
        const appStatusen: IAppStatus = {
            ClientId: +locationId,
        };

        const locationDetails = await getLocationDetail(locationId, location)
        const applicationStore = useApplicationStore();

        if (location === 'proforma') {
            appStatusen.ProformaId = +locationId;
            appStatusen.SetupID = locationDetails.AGENCY_ID;
            appStatusen.VesselId = locationDetails.VESSEL_ID;
        } else if (location === 'vessel') {
            appStatusen.SetupID = applicationStore.agencyIdSelected ?? undefined
            appStatusen.VesselId = +locationId;
        } else if (location === 'client') {
            appStatusen.SetupID = applicationStore.agencyIdSelected ?? undefined
            appStatusen.ClientId = +locationId;
        } else { // portcall and its related tabs
            const appStatusStore = useAppStatusStore();
            const appStoreStatus = appStatusStore.getAppStatus;
            appStatusen.PortCall = appStoreStatus.PortCall;
            appStatusen.SetupID = locationDetails.SETUP_ID;
            appStatusen.VesselId = locationDetails.VESSEL_ID;
            if (portcallProformaId) {
                appStatusen.ProformaId = portcallProformaId;
            }
        }

        appStatus = JSON.stringify(appStatusen);
    }

    const param = { guid, templateId, location, foreignKey: locationId, appStatus, isEmail, emailGeneration: emailGeneration ? generationOptions : undefined };
    const result = await apiPut('document/generate/', param) as unknown as GatResponseResult<any>;
    return result;
}
